import styled from "styled-components";

const HomeFooterWrapper = styled.div`
  background-color: #f8f9fa;
  margin-top: 40px;
  padding: 24px 16px;
  font-weight: 400;
  font-size: 12px;
  color: #4a5056;

  a {
    color: #4a5056;
  }

  .explain-text {
    margin-top: 16px;
    color: #000000;
  }

  .require-text {
    margin-top: 8px;
  }

  .social-section {
    display: flex;
    align-items: center;
    margin-top: 16px;

    span {
      cursor: pointer;
      display: flex;
      align-items: center;

      p {
        margin-left: 4px;
        color: #4a5056;
      }

      :nth-child(2) {
        margin-left: 32px;
      }
    }
  }
`;

export { HomeFooterWrapper };
